import React, { useEffect, useState } from "react";
import { listOutbox, initOutbox } from "@/lib/outbox";
import PendingUploads from "@/components/PendingUploads";
import { WifiSlash, CloudArrowUp, CheckCircle } from "@phosphor-icons/react";

export default function SyncChip() {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const refresh = () => listOutbox().then((l) => setPending(l.length)).catch(() => {});
    const on = () => { setOnline(true); refresh(); };
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    const stop = initOutbox(() => refresh());
    const t = setInterval(refresh, 5000);
    refresh();
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); stop(); clearInterval(t); };
  }, []);

  const state = !online ? "offline" : pending > 0 ? "syncing" : "synced";
  const cfg = {
    offline: { cls: "bg-[#3A3A3A] text-white", icon: <WifiSlash size={13} weight="bold" />, label: `Offline${pending ? ` · ${pending} queued` : ""}` },
    syncing: { cls: "bg-accent-tint text-accent-ink border border-accent-edge", icon: <CloudArrowUp size={13} weight="bold" />, label: `Sending ${pending}…` },
    synced: { cls: "bg-white/10 text-white", icon: <CheckCircle size={13} weight="bold" className="text-emerald-400" />, label: "Synced" },
  }[state];

  return (
    <>
      <button type="button" data-testid="sync-chip" data-sync-state={state}
        onClick={() => pending && setOpen(true)}
        className={`inline-flex items-center gap-1.5 h-7 px-2.5 rounded-full text-[11px] font-bold ${cfg.cls} ${pending ? "cursor-pointer" : "cursor-default"}`}>
        {cfg.icon} {cfg.label}
      </button>
      <PendingUploads open={open} onClose={() => setOpen(false)} />
    </>
  );
}
